$shm_file_drop $mol_button_open
	multiple false
	title <= drop_title \Перетащите файл
	drag_active? false
	sub /
		<= Icon
		<= Label $mol_text
			text <= drop_title \Перетащите файл
		<= Native
	attr *
		^
		shm_file_drop_drag <= drag_active false
	event *
		^
		dragenter? <=> drag_enter? null
		dragover? <=> drag_over? null
		dragleave? <=> drag_leave? null
		drop? <=> file_drop? null
